import { SVGProps, SVGAttributes } from 'react';

const PastReportsIcon = (props: SVGProps<SVGAttributes<SVGSVGElement>>) => {
    const { stroke } = props;

    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_6_409" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
                <rect width="48" height="48" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_6_409)">
                <path d="M16 24H32V20H16V24ZM16 16H32V12H16V16ZM39.9 40.95L31.8 30.4C31.2333 29.6333 30.5333 29.0417 29.7 28.625C28.8667 28.2083 27.9667 28 27 28H8V8C8 6.9 8.39167 5.95833 9.175 5.175C9.95833 4.39167 10.9 4 12 4H36C37.1 4 38.0417 4.39167 38.825 5.175C39.6083 5.95833 40 6.9 40 8V40C40 40.1667 39.9917 40.325 39.975 40.475C39.9583 40.625 39.9333 40.7833 39.9 40.95ZM12 44C10.9 44 9.95833 43.6083 9.175 42.825C8.39167 42.0417 8 41.1 8 40V32H27C27.3333 32 27.6417 32.075 27.925 32.225C28.2083 32.375 28.45 32.5833 28.65 32.85L37.05 43.85C36.8833 43.9167 36.7083 43.9583 36.525 43.975C36.3417 43.9917 36.1667 44 36 44H12Z"
                      fill={stroke || "#206FA5"}
                />
            </g>
        </svg>

    );
};

export default PastReportsIcon;
